;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import SvgIcon from 'components/ui/SvgIcon';

import styles from './ButtonCircle.module.scss';

const ButtonCircle = ({
    as,
    className,
    theme,
    iconType,
    iconClassName,
    children,
    ...props
}) => {
    const Tag = as ?? 'button';

    const iconLabels = {
        chevronRight: 'Next',
        chevronLeft: 'Previous',
        chevronDown: 'Expand',
        playVideo: 'Play video',
        arrowRight: 'Next',
        arrowLeft: 'Previous',
        arrowRightRounded: 'Next',
        add: 'Add',
        plus: 'Add',
        minus: 'Remove',
        close: 'Close',
    };

    return (
        <Tag className={cx(styles.root, styles[theme], className)} {...props}>
            <SvgIcon
                className={cx(styles[`icon-${iconType}`], iconClassName)}
                type={iconType}
            />
            {!children && (
                <span className="sr-only">
                    {iconLabels[iconType] || 'Button'}
                </span>
            )}
            {children}
        </Tag>
    );
};

ButtonCircle.propTypes = {
    as: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    theme: PropTypes.oneOf([
        'small-fill-blue',
        'small-fill-cream',
        'small-fill-gold',
        'small-fill-white',
        'small-fill-orange',
        'small-fill-bluedark',
        'small-fill-creamdark',
        'small-fill-makers-brown',
        'large-thick-blue',
        'large-thick-cream',
    ]),
    iconType: PropTypes.oneOf([
        'chevronRight',
        'chevronLeft',
        'chevronDown',
        'playVideo',
        'arrowRight',
        'arrowLeft',
        'arrowRightRounded',
        'add',
        'plus',
        'minus',
        'close',
    ]),
};

export default ButtonCircle;
